import { useContext, useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import CryptoJS from 'crypto-js';

import './mala-redirect.scss';

import { Loader } from '../../../components/atoms';

import { AuthService } from '../../../services';
import { UserContext } from '../../../context';

const MalaRedirect = () => {
  const { user, setUser } = useContext(UserContext);
  const history = useHistory();
  const [triggered, setTriggered] = useState('');
  const [sessionData, setSessionData] = useState(null);
  const [hasUploaded, setHasUploaded] = useState(false);



  useEffect(() => {
    // logoutDifferentUser();
    getRoute();
  }, []);

  const assignRole = (roles) => {
    if (roles.includes("SUPERADMIN")) {
      return "SUPERADMIN"
    }
    else if (roles.includes("ADMIN")) {
      return "ADMIN"
    }
    else {
      return ""
    }
  }

  const getEncryptedParams = data =>
    CryptoJS.AES.encrypt(data, process.env.REACT_APP_AUTH_KEY).toString();

  const DencryptedParams = data => {
    try {
      const key = process.env.REACT_APP_AUTH_KEY;
      return CryptoJS.AES.decrypt(data, key || '').toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log(error);
      return '';
    }
  };

  const logoutDifferentUser = () => {
    const path = window.location.pathname?.toLowerCase();
    if (path?.includes('mala/')) {
      const startIndex = path.indexOf('mala/');
      const receivedData = window.location.pathname.slice(startIndex + 5);
      const decoded = atob(receivedData);
      const decrypted = DencryptedParams(decoded);
      const parsed = JSON.parse(decrypted);
      if (parsed.u !== user?.username && user?.authenticated) {
        localStorage.removeItem('user');
        setUser(null);
      }
    }
  };


  const applysessionData = (sessionData,receivedData) => {
    // once we get 'user' data it will be set on sessionStorage on BB.
      try {
        setTriggered('checked');
        let stateObject;
        const sessionObj = JSON.parse(sessionData);
         // validating the timestamp only for one minute
        if (Date.now() - sessionObj?.currentTimeStamp >= 60 * 1000) {
           history.push("/signIn");
          return;
        }
        stateObject = {
          username: sessionObj?.username,
          tokens: {
            ...sessionObj.tokens,
            accessToken: {
              ...sessionObj.tokens.accessToken,
              jwtToken: sessionObj.tokens.accessToken.token,
            },
          },
          name: sessionObj?.name,
          authenticated: true,
          isMalaRedirect: true,
          loggedIn: true,
          role: assignRole(sessionObj.roles),
          isSSO: sessionObj?.isSSO,
          appId: sessionObj?.appId,
           redirectData: {
             blsData: {
               expId: receivedData?.e,
               studyId: receivedData?.s,
               hasUploaded: receivedData?.dt,
	             },
             redirectPath: receivedData?.r,
           },
           dropdowns: {
            businessManager: { label: '', value: receivedData?.b },
            adaccount: { label: '', value: receivedData?.a },
          }
        };
        localStorage.setItem("user", JSON.stringify(stateObject));
        setUser(stateObject);
        setTriggered('checked');
          window.location.href = receivedData?.dt ? `/view-bls-study?accountId=${receivedData?.s}` : `/add-bls-study?accountId=${receivedData?.a}`;
      } catch (e) {
         history.push("/signIn");
      }
    }

  const loginIntoMIA = async receivedData => {
    setTriggered('checking');
    try {
      if (receivedData?.sId) {
        const sId = receivedData?.sId;
        setHasUploaded(receivedData?.dt);
        const data = await AuthService.upaSessionAuth(sId);
        if (data?.status === 200) {
          applysessionData(data?.data?.data?.sessionData,receivedData);
        } else {
          localStorage.removeItem('user')
          history.push("/signIn");
        }

      } else {
        localStorage.removeItem('user')
        history.push("/signIn");
      }
    } catch (error) {
      setTriggered('checked');
      history.replace('/signIn');
    }
  };



  const getRoute = () => {
    try {
      const path = window.location.pathname?.toLowerCase();
      if (path?.includes('mala/')) {
        const startIndex = path.indexOf('mala/');
        const receivedData = window.location.pathname.slice(startIndex + 5);
        const decoded = atob(receivedData);
        const decrypted = DencryptedParams(decoded);
        const parsed = JSON.parse(decrypted);
        // condition to get the details only once, and then sign in
        // since this method will be called repeatively if not authenticated
        !triggered && loginIntoMIA(parsed);
        return <div></div>;
      }
      // return <Redirect to="/signIn" />;
      return <div></div>;
    } catch (error) {
      
    }
  };

  return <Loader />;
}

export default MalaRedirect;
